<template>
<div>
  <!-- div wrapper is required for router to properly function with model -->
  <div class="ui small modal" id="resetPasswordModal">
    <i class="close icon"></i>

    <div class="header">
      BIOveikals: Paroles atjaunošana
    </div>
    <div class="content">
      <div class="ui middle aligned grid">
        <div class="column">
          <div v-if="storeStatus.error != ''" class="ui negative message">
            Pārbaudi e-pastu un paroli!
          </div>
          <div v-if="resetOk" class="ui positive message">
            Instrukcija par paroles atjaunošanu ir nosūtīta uz tavu e-pastu!
          </div>
          <div class="ui  center aligned  form">

            <div class="ui  segment">
              <div class="field">
                <div class="ui left icon input">
                  <i class="user icon"></i>
                  <input v-model="credentials.email" type="email" placeholder="E-pasts">
                </div>
              </div>
              <button v-on:click="requestPasswordReset" :disabled="credentials.email == ''" class="ui fluid large custom_brown button" v-bind:class="{ loading: storeStatus.loading }">Atjaunot paroli</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {

  data() {
    return {
      credentials: {
        email: '',
        password: ''
      },
      showModal:true,
      resetOk:false
    }
  },

  computed: {
    storeStatus() {
      return this.$store.state.userStore.status
    }
  },


  activated: function() {

    this.resetOk = false;
    //clear previous token and user data
    this.$store.dispatch('logoutUser');


    var self = this;
    $('#resetPasswordModal')
      .modal({
        blurring: true,
        onHidden: function(){

          self.$router.push({
            name: 'home'
          });

        },
      })
      .modal('setting', 'closable', false)
      .modal('show');



  },

  deactivated: function() {

  },

  methods: {


    requestPasswordReset() {

        if(this.credentials.email == '') return; //dont submit empty

      this.$store.dispatch('requestPasswordReset', this.credentials).then((response) => {
        this.credentials.email = ""; //reset credentials so that they dont hang in local component state
        this.resetOk = true;

      }).catch((error) => {
        this.resetOk = false;
      });

    }
  }

}
</script>

<style>
.ms-pointer {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// ResetPasswordPage.vue?439d2966